export default "__VITE_ASSET__dD$2uYAQ__"